import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const storeDevtoolsInstrument = [
  StoreDevtoolsModule.instrument()
];
